import React, { useEffect, useState } from 'react';

import Header from '../../../layout/Header';
import Subheader from '../../../layout/Subheader';
import api from '../../../services/api';
import TableContent from './TableContent';
import OperationsMiddle from './OperationsMiddle';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import * as S from './styles';
import { useMessageBox } from '../../../context/MessageBox';
import { useNotification } from '../../../context/NotificationContext';
import { TOKEN_USER } from '../../../services/auth';
import Loading from '../../../components/Loading';

export function TargetReport() {
  const { periodo } = useParams();
  const { setAnchorId } = useNotification();
  const { setMessageData } = useMessageBox();

  const loginId = JSON.parse(sessionStorage.getItem(TOKEN_USER))?.loginId;
  const [anchors, setAnchors] = useState([]);
  const [selectedAnchor, setSelectedAnchor] = useState(null);

  const [selectedProvider, setSelectedProvider] = useState('');
  const [providerInfo, setProviderInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoader] = useState(true);
  const [proposeProps, setProposeProps] = useState({ isPropose: false, origin: '' });
  const [updateMeta, setUpdateMeta] = useState(false);
  const [updateMetaData, setUpdateMetaData] = useState(false);
  const [intervalTime, setintervalTime] = useState(0);
  const [tableData, setTableData] = useState();
  const [totalTableData, setTotalTableData] = useState();
  const [headerData, setHeaderData] = useState();
  const [mediaCrescimento, setmediaCrescimento] = useState(true);
  const [hideColumns, setHideColumns] = useState(true);
  const [allowChange, setAllowChange] = useState(false);
  const [scheduleDate, setScheduleDate] = useState(new Date());
  const [liberarMetasChanged, setLiberarMetasChanged] = useState(false)

  const [screenParams, setScreenParams] = useState({
    title: periodo === 'diario' ? 'Relatório Diário' : 'Relatório Mensal',
  });

  const [updateContent, setUpdateContent] = useState(Date.now());
  const reloadPage = async (
    provider,
    origemParam = '',
    proposePropsParam = { isPropose: false, origin: '' },
  ) => {
    setTimeout(() => {
      setSelectedProvider({ ...provider, origemProv: origemParam });
      setProviderInfo(provider);
      setProposeProps(proposePropsParam);
    }, 1);
  };

  const fetchAvailableAnchors = async () => {
    // const message = await api.put('_API/MensagemBoxParametrosDefinidos');
    // setMessageData(message?.data?.complemento?.mensagensBox);
    const { data } = await api.get(
      `Relatorios/ConsultarPlataformasAncorasAnalistas?loginId=${loginId}&moduloId=Relatorio002Metas`,
    );
    if(data.resposta.redes || data.resposta.plataformas || data.resposta.redeCapittale) {
      const anchor = data.resposta.redeCapittale.ancoraId > 0 ? data.resposta.redeCapittale :
      (data.resposta?.redes.length > 0 ? data.resposta?.redes[0] : 
        (data.resposta?.plataformas.length > 0 ? data.resposta.plataformas[0]: {}));
      setAnchors(data.resposta);
      setSelectedAnchor(anchor);
      setAnchorId(anchor.ancoraId ? anchor.ancoraId : (anchor.plataformaId ? anchor.plataformaId : 0));
    } else if (data.resposta.length > 0) {
      setAnchors(data.resposta);
      setSelectedAnchor(data.resposta[0]);
      setAnchorId(data.resposta[0].ancoraId);
    } else {
      setAnchors([]);
      setSelectedAnchor({});
      setAnchorId(0);
    }
  };

  const handleSelectAnchor = (anchor) => {
    setAnchorId(anchor?.ancoraId);
    setSelectedAnchor(anchor);
    setSelectedProvider('');
  };

  const onSubmit = () => {
    setUpdateMeta(true);
  };

  useEffect(() => {
    if (intervalTime > 0) {
      const interval = setInterval(() => setUpdateContent(Date.now()), intervalTime);
      return () => {
        clearInterval(interval);
      };
    }
  }, [intervalTime]);

  useEffect(() => {
    isLoading
      ? localStorage.setItem('isLoading', 'true')
      : localStorage.setItem('isLoading', 'false');
    setTimeout(() => {
      setLoader(localStorage.getItem('isLoading') === 'true');
    }, 200);
  }, [isLoading]);

  useEffect(() => {
    fetchAvailableAnchors();
    setintervalTime(
      Number(
        JSON.parse(
          sessionStorage.getItem('@Capittale-Web-Setting'),
        )?.configuracoesAmbienteWeb?.find((el) => el.parametroId === 40)?.valor ?? 0,
      ) *
        1000 *
        60,
    );
  }, []);

  const liberarMetas = async () => {
    setIsLoading(true)
    const response = await api.post('Relatorios/Relatorio002MetasLiberarCar',
    {anoMeta: new Date(scheduleDate).getFullYear(), mesMeta: new Date(scheduleDate).getMonth() + 1,})

    if (response?.data?.complemento?.mensagensBox?.length > 0) {
      setMessageData(response?.data?.complemento?.mensagensBox);
    }

    if (response.data.status == 'Sucesso') {
      toast.success('Metas liberadas com sucesso!');
    }
    
    setLiberarMetasChanged(true);
  }

  return (
    <S.Root>
      <Header />
      <Subheader
        title={'Relatório Metas'}
        back="/app/home"
        submit={onSubmit}
        submitText={'Atualizar'}
        isDisabled={!allowChange}
        loading={isLoading}
        extraBtn={headerData ? headerData.mostrarBotaoLiberarCar : false}
        extraBtnText={'Liberar Metas p/ CAR'}
        extraBtnFunction={liberarMetas}
      />
      <S.Content style={{ display: 'flex' }}>
        <div
          style={{
            width: '100%',
            margin: '30px 30px',
            padding: '0px 20px 20px 20px',
            height: '100%',
            border: '2px solid #ddd',
            borderRadius: '8px',
            backgroundColor: '#eee',
          }}
        >
          <OperationsMiddle
            setTableData={setTableData}
            setmediaCrescimento={setmediaCrescimento}
            setHeaderData={setHeaderData}
            setTotalTableData={setTotalTableData}
            updateMetaData={updateMetaData}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hideColumns={hideColumns}
            setHideColumns={setHideColumns}
            setAllowChange={setAllowChange}
            anchors={anchors}
            handleSelectAnchor={handleSelectAnchor}
            selectedAnchor={selectedAnchor}
            scheduleDate={scheduleDate}
            setScheduleDate={setScheduleDate}
            setLiberarMetasChanged={setLiberarMetasChanged}
            liberarMetasChanged={liberarMetasChanged}
          />
        </div>
      </S.Content>
      {loader ? (
        <Loading />
      ) : (
        <div>
          <TableContent
            tableData={tableData}
            mediaCrescimento={mediaCrescimento}
            headerData={headerData}
            totalTableData={totalTableData}
            updateMeta={updateMeta}
            setUpdateMeta={setUpdateMeta}
            setUpdateMetaData={setUpdateMetaData}
            hideColumns={hideColumns}
            allowChange={!allowChange}
          />
        </div>
      )}
    </S.Root>
  );
}
